import React from "react";
import styled, { css } from "styled-components";
import { px2rem } from "../../../ezUI/StyledComponents/utils";
import { lsSetItem, lsGetItem, lsRemoveItem } from "../../../utils/safeWebStorage";
import getLangKeyValueFun from "../../../utils/lang";
import { AssetImageUrl } from "../../../assets/imgUrl";
import { getKeywordSearch, getTopKeywords } from "../../../services/header/header";
import Constant, { Host } from "../../../utils/constant";
import langGroup from "../../../assets/lang.json";
const gettext = getLangKeyValueFun(langGroup);
let timeoutId = null;
const Container = styled.div `
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	z-index: 3000;
	background: #ffffff;
	font-size: ${px2rem(14)};
	color: #333333;
	padding-top: ${px2rem(50)};
`;
const Header = styled.div `
	display: flex;
	align-items: center;
	position: fixed;
	top: 0;
	width: 100%;
	height: ${px2rem(50)};
	background: #eee;
	border-top: 1px solid #ddd;
	border-bottom: 1px solid #ddd;
	padding-right: ${px2rem(9)};
	z-index: 10;
	box-sizing: border-box;
`;
const Close = styled.div `
	width: ${px2rem(45)};
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;
const SearchItem = styled.form `
	flex: 1;
	height: ${px2rem(34)};
	border-radius: ${px2rem(4.5)};
	border: 1px solid #bfbfbf;
	position: relative;
	> input {
		width: 100%;
		height: ${px2rem(32)};
		padding: 0 ${px2rem(40)} 0 ${px2rem(5)};
		border: none;
		color: #333;
		border-radius: ${px2rem(4.5)};
		font-size: ${px2rem(12)};
		box-sizing: border-box;
		outline: none;
	}
`;
const Inputdelete = styled.img `
	position: absolute;
	right: ${px2rem(40)};
	top: 50%;
	cursor: pointer;
	transform: translateY(-50%);
`;
const SearchButton = styled.button `
	position: absolute;
	right: 0;
	top: 0;
	width: ${px2rem(34)};
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background: -moz-linear-gradient(top, #fff, #f0f0f0);
	background: -webkit-gradient(linear, top, from(#fff), to(#f0f0f0));
	background: -webkit-linear-gradient(top, #fff, #f0f0f0);
	background: -o-linear-gradient(top, #fff, #f0f0f0);
	border: none;
	border-left: 1px solid #bfbfbf;
	border-radius: 0 ${px2rem(4.5)} ${px2rem(4.5)} 0;
	outline: none;
`;
const SearchKey = styled.div `
	position: absolute;
	top: 0;
	width: 100%;
	height: 100%;
	padding: 0 ${px2rem(16)};
	background: #ffffff;
	box-sizing: border-box;
	padding-top: ${px2rem(52)};
	overflow-y: scroll;
	overflow-x: hidden;
	> div {
		margin-top: ${px2rem(12)};
	}
`;
const RecentHeader = styled.div `
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: ${px2rem(17)};
	> span {
		font-weight: 800;
	}
`;
const HistoryKeys = styled.div `
	> div {
		display: inline-block;
		padding: ${px2rem(3)} ${px2rem(7)};
		margin: 0 ${px2rem(13)} ${px2rem(20)} 0;
		background-color: #f2f2f2;
		border: #d1d1d1 1px solid;
		color: #333;
	}
`;
const TopList = styled.div `
	padding-bottom: ${px2rem(100)};
	> div {
		display: flex;
		align-items: center;
		margin-bottom: ${px2rem(17)};
	}
`;
const WorldsArrow = styled.img `
	transform: rotate(-20deg);
`;
const TopIndex = styled.div `
	width: ${px2rem(18)};
	height: ${px2rem(18)};
	line-height: ${px2rem(18)};
	font-size: ${px2rem(12)};
	background-color: #d1d1d1;
	border-radius: ${px2rem(4.5)};
	margin-right: ${px2rem(12)};
	text-align: center;
	color: #fff;
	${(props) => props.red &&
    css `
			background-color: #e33124;
		`};
`;
const Words = styled.div `
	flex: 1;
`;
const Clear = styled.div `
	display: flex;
	align-items: center;
	color: #888;
	> img {
		margin-right: ${px2rem(4.5)};
	}
`;
const ResultList = styled.div `
	position: absolute;
	top: 0;
	width: 100%;
	height: 100%;
	background: #ffffff;
	box-sizing: border-box;
	padding-top: ${px2rem(52)};
	padding-bottom: ${px2rem(100)};
	overflow-y: scroll;
	overflow-x: hidden;
	> div {
		display: flex;
		align-items: center;
		width: 100%;
		height: ${px2rem(45)};
		border-bottom: 1px solid #d1d1d1;
		padding: 0 ${px2rem(15)};
		font-size: ${px2rem(16)};
	}
`;
const LocalIcon = styled.img `
	margin-right: ${px2rem(10)};
`;
const AutoWords = styled.div `
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	flex: 1;
`;
class Search extends React.Component {
    constructor(props) {
        super(props);
        this.searchInput = e => {
            const self = this;
            this.setState({
                searchText: e.target.value || ""
            }, () => {
                clearTimeout(timeoutId);
                if (this.state.searchText === "") {
                    this.setState({ showResult: false });
                    return;
                }
                else {
                    timeoutId = setTimeout(function () {
                        self.autocomplete();
                    }, 200);
                }
            });
        };
        this.clearInput = () => {
            this.setState({
                searchText: "",
                showResult: false
            });
        };
        this.handleSearch = e => {
            const { searchText } = this.state;
            if (searchText === "") {
                e.preventDefault();
                return;
            }
            let list = [];
            try {
                list = JSON.parse(lsGetItem("RECENT_SEARCH_LIST")) || [];
            }
            catch (e) {
                list = [];
            }
            if (!list.some(preItem => preItem === searchText)) {
                list.push(searchText);
                lsSetItem("RECENT_SEARCH_LIST", JSON.stringify(list));
            }
            lsSetItem("RECENT_SEARCH_LIST", JSON.stringify(list));
            this.goSearch(searchText);
        };
        this.goSearch = val => {
            const BaseUrl = Host[String(Constant.isUat)];
            window.location.href = `${BaseUrl.mHost}/${Constant.language}/search?q=${val}`;
        };
        this.setRecentSearchList = () => {
            if (this.state.searchText && 0 in this.state.recentSearchList) {
                return;
            }
            if (!this.state.searchText) {
                let recentSearchList = [];
                try {
                    recentSearchList = JSON.parse(lsGetItem("RECENT_SEARCH_LIST")) || [];
                }
                catch (e) {
                    recentSearchList = [];
                }
                recentSearchList = [...recentSearchList].reverse().slice(0, 6);
                recentSearchList = Array.from(new Set([...recentSearchList]));
                this.setState({ recentSearchList });
            }
            else {
                this.setState({ recentSearchList: [] });
            }
        };
        this.autocomplete = () => {
            getKeywordSearch({
                word: this.state.searchText,
                num: 10
            }, { onSentryCatch: this.props.onSentryCatch }).then((res) => {
                if (this.state.searchText !== "") {
                    let { keywords = [] } = res.info || [];
                    let localResult = [];
                    this.state.recentSearchList.map(item => {
                        if (item.indexOf(this.state.searchText) === 0) {
                            localResult.push({ keyword: item, isLocalHistory: true });
                        }
                    });
                    if (localResult.length > 0) {
                        keywords = localResult.concat(keywords);
                    }
                    this.setState({
                        keywords,
                        showResult: true
                    });
                }
            })
                .catch(err => {
                console.log(err);
            });
        };
        this.clearRecent = () => {
            lsRemoveItem("RECENT_SEARCH_LIST");
            this.setState({ recentSearchList: [] });
        };
        this.state = {
            showResult: false,
            searchText: "",
            recentSearchList: [],
            topKeyWords: [],
            keywords: []
        };
    }
    componentDidMount() {
        getTopKeywords({ category_id: 0 }, { onSentryCatch: this.props.onSentryCatch })
            .then((res) => {
            let topKeyWords = res.info || [];
            this.setState({ topKeyWords: topKeyWords.slice(0, 10) });
        })
            .catch(err => {
            console.log(err);
        });
    }
    render() {
        const { showResult, searchText, topKeyWords, recentSearchList, keywords } = this.state;
        const { stateChange } = this.props;
        const BaseUrl = Host[String(Constant.isUat)];
        return (React.createElement(Container, null,
            React.createElement(Header, null,
                React.createElement(Close, { onClick: () => stateChange("showSearchModal", false) },
                    React.createElement("img", { src: AssetImageUrl["ic_closed2@3x.png"], width: 18 })),
                React.createElement(SearchItem, { action: `${BaseUrl.mHost}/${Constant.language}/search`, "accept-charset": "utf-8", id: "search_form", method: "get", onSubmit: this.handleSearch },
                    React.createElement("input", { name: "q", id: "q", value: searchText, autoComplete: "off", placeholder: gettext("Search"), onChange: this.searchInput, onFocus: this.setRecentSearchList, type: "search" }),
                    searchText !== "" && (React.createElement(Inputdelete, { src: AssetImageUrl["ic_deleted@3x.png"], width: 18, onClick: this.clearInput })),
                    React.createElement(SearchButton, { onClick: this.handleSearch, type: "submit" },
                        React.createElement("img", { src: AssetImageUrl["ic_search@3x.png"], width: 18 })))),
            React.createElement(SearchKey, null,
                recentSearchList && recentSearchList.length > 0 ? (React.createElement("div", null,
                    React.createElement(RecentHeader, null,
                        React.createElement("span", null, gettext("Recent Searches")),
                        React.createElement(Clear, { onClick: this.clearRecent },
                            React.createElement("img", { src: AssetImageUrl["ic_clear@3x.png"], width: 18 }),
                            React.createElement("span", null, gettext("Clear")))),
                    React.createElement(HistoryKeys, null, recentSearchList.map((item, index) => {
                        return (React.createElement("div", { key: index, onClick: () => this.goSearch(item) }, item));
                    })))) : null,
                topKeyWords && topKeyWords.length > 0 ? (React.createElement("div", null,
                    React.createElement(RecentHeader, null,
                        React.createElement("span", null, gettext("Top Keywords"))),
                    React.createElement(TopList, null, topKeyWords.map((item, index) => {
                        return (React.createElement("div", { key: index, onClick: () => this.goSearch(item.keywords) },
                            React.createElement(TopIndex, { red: !!item.markRed }, index + 1),
                            React.createElement(Words, null, item.keywords),
                            React.createElement(WorldsArrow, { src: AssetImageUrl["ic_箭头@3x.png"], width: 14 })));
                    })))) : null),
            showResult && (React.createElement(ResultList, null, keywords.map((item, index) => {
                return (React.createElement("div", { key: index, onClick: () => this.goSearch(item.keyword) },
                    item.isLocalHistory && (React.createElement(LocalIcon, { src: AssetImageUrl["ic_time@3x.png"], width: 18 })),
                    React.createElement(AutoWords, null, item.keyword),
                    React.createElement(WorldsArrow, { src: AssetImageUrl["ic_箭头@3x.png"], width: 14 })));
            })))));
    }
}
export default Search;
